// Who eats along (spec E1): which block of a day is the evening meal, and how it reads.

/** The evening meal of a day: the last meal block that is not a step of a group (breakfast is a morning step). */
export function dinnerBlockId<T extends { id: string; slot_kind: string; group_title: string | null; start_local: string }>(
  blocks: T[],
): string | null {
  const meals = blocks.filter((b) => b.slot_kind === "meal" && !b.group_title).sort((a, b) => (a.start_local < b.start_local ? -1 : 1));
  return meals[meals.length - 1]?.id ?? null;
}

/** "Met Tsjits", "Met Tsjits en Vriend", "Alleen", or "Uit eten". */
export function mealLine(place: "home" | "out", names: string[]): string {
  if (place === "out") return "Uit eten";
  if (!names.length) return "Alleen";
  const list = names.length === 1 ? names[0] : `${names.slice(0, -1).join(", ")} en ${names[names.length - 1]}`;
  return `Met ${list}`;
}

/** The ingredients of several recipes as one list: the same name once, with the amounts together (golf 9). */
export function mergeIngredients(
  recipes: { id: string; ingredients: { name: string; amount: string | null }[] }[],
): { name: string; amount: string | null; recipeIds: string[] }[] {
  const byName = new Map<string, { name: string; amounts: string[]; recipeIds: string[] }>();
  for (const r of recipes) {
    for (const i of r.ingredients) {
      const key = i.name.trim().toLowerCase();
      const row = byName.get(key) ?? { name: i.name.trim(), amounts: [], recipeIds: [] };
      if (i.amount?.trim()) row.amounts.push(i.amount.trim());
      if (!row.recipeIds.includes(r.id)) row.recipeIds.push(r.id);
      byName.set(key, row);
    }
  }
  return [...byName.values()]
    .map((r) => ({ name: r.name, amount: r.amounts.length ? r.amounts.join(" + ") : null, recipeIds: r.recipeIds }))
    .sort((a, b) => a.name.localeCompare(b.name));
}
